const dns_table = {
	/* -------------------------------------------------------------------------- */
	/*                               ERROR MESSAGES                               */
	/* -------------------------------------------------------------------------- */
	error_messages: {
		ERR_A_1:
			"Die eingegebene IPv4-Adresse ist ungültig. Prüfen Sie, ob sie das richtige Format hat (z.B. 192.168.1.1) und ob jedes Segment eine Zahl zwischen 0 und 255 ist.",
		ERR_AAAA_1:
			"Die eingegebene IPv4-Adresse ist ungültig. Prüfen Sie, ob sie das richtige Format hat (z.B. 192.168.1.1) und ob jedes Segment eine Zahl zwischen 0 und 255 ist.",
		ERR_CNAME_1: "Ein CNAME-Eintrag darf kein @ als Bezeichnung haben.",
		ERR_CNAME_2:
			"Ein CNAME-Eintrag muss einen gültigen Domainnamen als Wert haben und mit einem Punkt (.) enden.",
		ERR_CNAME_3: "Das Label existiert bereits für einen anderen CNAME-Eintrag.",
		ERR_LABEL_1: "Das aktuelle Etikett ist nicht zulässig.",
		ERR_MX_1:
			"Ein MX-Eintrag muss einen gültigen Domainnamen als Wert haben und mit einem Punkt (.) enden.",
		ERR_NONE_1: "Es scheint, dass die eingegebenen DNS-Daten falsch sind.",
		ERR_NS_1: "Ein NS-Datensatz darf kein @ als Etikett haben.",
		ERR_NS_2:
			"Ein NS-Eintrag muss einen gültigen Domainnamen als Wert haben und mit einem Punkt (.) enden.",
		ERR_SRV_1:
			"Ungültige Bezeichnung für SRV-Datensatz: Überprüfen Sie, ob die Bezeichnung korrekt eingegeben wurde.",
		ERR_SRV_2: "Ungültiger Wert für SRV-Eintrag: Prüfen Sie, ob der Wert richtig eingegeben wurde.",
		ERR_SRV_3: "Gewicht und Portnummern müssen zwischen 0 und 65535 liegen.",
	},
	/* -------------------------------------------------------------------------- */
	/*                                   HEADER                                   */
	/* -------------------------------------------------------------------------- */
	header: {
		label: {
			label: "Etikett",
			tooltip:
				"Die zu bezeichnende Domain oder Subdomain. Verwenden Sie @ für Ihre StandardDomain (z.B. niceexample.com). Geben Sie in dieses Feld nicht den Domainnamen ein (oder www, nicht www.niceexample.com).",
		},
		priority: {
			label: "Priorität",
		},
		ttl: {
			label: "TTL",
			tooltip:
				"Anzahl der Sekunden, die die DNS-Server auf die Erneuerung des Eintrags warten. Eine kürzere TTL bedeutet schnellere DNS-Aktualisierungen in der Zukunft. Längere TTLs bieten mehr Toleranz und bessere Leistung.",
		},
		type: {
			label: "Typ",
			tooltip:
				"Der DNS-Typ bestimmt die Anforderungen und das Verhalten des Eintrags. Jeder DNS-Typ gibt unterschiedliche Informationen über die Domain an den DNS-Server weiter.",
		},
		value: {
			label: "Wert",
			tooltip: "Datensatzziel: Der Wert variiert je nach Datensatztyp.",
		},
	},

	/* -------------------------------------------------------------------------- */
	/*                                  TABLE ROW                                 */
	/* -------------------------------------------------------------------------- */
	row: {
		buttons: {
			cancel: "Abbrechen",
			delete: "Entfernen",
			edit: "Bearbeiten",
			ok: "OK",
		},
		empty: "Keine DNS-Einträge gefunden",
		label: {
			A: "Zum Beispiel @ oder www",
			AAAA: "Zum Beispiel @ oder www",
			CNAME: "Zum Beispiel api oder blog",
			empty: "Typ wählen",
			MX: "Zum Beispiel @ oder mail",
			NS: "Zum Beispiel @ oder mail",
			none: "Zum Beispiel @ oder www",
			SRV: "_xmpp._tcp.example.com.",
			TLSA: "_443._tcp.example.com.",
			TXT: "Zum Beispiel @ oder mail",
		},
		type: {
			placeholder: "Typ wählen",
		},
		value: {
			A: "XX.XX.XX.XX",
			AAAA: "XX:XX:XX:XX:XX:XX:XX:XX",
			CNAME: "example.com",
			MX: "smtp.example.com",
			NS: "ns1.example.com",
			none: "XX.XX.XX.XX",
			SRV: "0 0000 service.example.com.",
			TLSA: "0 0 0 d2abde240d7cd3ee6b4b28c54df034b97983a1d16e8a410e4561cb106618e971",
			TXT: "Ein textueller Wert",
		},
	},
};

export default dns_table;
